import { httpClient } from "src/utils/HttpClient";
import Swal from "sweetalert2";

export const fetchConditionContract = () => {
  return (dispatch) => {
    dispatch({ type: "CONDITION_CONTRACT_FETCH" });
    httpClient
      .get(`/purchase-request/condition-contract`)
      .then(({ data }) => {
        dispatch({ type: "CONDITION_CONTRACT_SUCCESS", payload: data });
      })
      .catch(() => {
        dispatch({ type: "CONDITION_CONTRACT_REJECTED" });
      });
  };
};

export const fetchBudgetList = () => {
  return (dispatch) => {
    dispatch({ type: "BUDGETS_LIST_FETCH" });
    httpClient
      .get(`/purchase-request/budgets`)
      .then(({ data }) => {
        dispatch({ type: "BUDGETS_LIST_SUCCESS", payload: data });
      })
      .catch((err) => {
        dispatch({ type: "BUDGETS_LIST_REJECTED" });
      });
  };
};

export const createConditionContract = (value) => {
  return httpClient
    .post(`/purchase-request/condition-contract`, value)
    .then(() => {
      Swal.fire({
        text: "Data saved",
        icon: "success",
      });
    })
    .catch((err) => {
      Swal.fire({
        title: "Oops...",
        text: err.message,
        icon: "error",
      });
    });
};

export const updateConditionContract = (id, value) => {
  return httpClient
    .put(`/purchase-request/condition-contract/${id}`, value)
    .then(() => {
      Swal.fire({
        text: "Data saved",
        icon: "success",
      });
    })
    .catch((err) => {
      Swal.fire({
        title: "Oops...",
        text: err.message,
        icon: "error",
      });
    });
};
